import React, { useEffect, useState } from 'react'
import styled, { keyframes } from 'styled-components'
import CreditCardOffIcon from '@mui/icons-material/CreditCardOff'
import { useSelector } from 'react-redux'
import paypal from '../media/paypal-logo.png'
import arrow from '../media/arrow.png'
import { base } from '../utils'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

function Upgrade() {
    const [res, setRes] = useState(null)

    const user = useSelector(state=> state.user.user)

    const subscribe = () => {
        fetch(`${base}/subscription`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                email: user.email
              })
            }).then(res=> res.json()).then(data=> {
              setRes(data)
            })
    }



    useEffect(()=> {
        if(res?.approvalUrl) {
            window.location.href = res.approvalUrl.url
        }
    }, [res])


  return (
    <UpgradeContainer>
        <h1>Choose your option</h1>
        <h4>MarketLab offers both a free and $20 per month option, making it affordable for everyone</h4>

        <CardsContainer>
            <Card className='reg'>
                <h2>Forever Free</h2>
                <ul style={{listStyleType: 'none'}}>
                    <li><CheckCircleOutlineIcon /> 60 free <span style={{color: '#de2699'}}>Nexilum</span> units per month</li>
                    <li><CheckCircleOutlineIcon /> Keyword research</li>
                    <li><CheckCircleOutlineIcon /> Competition research</li>
                    <li><CheckCircleOutlineIcon /> Website testing (speed, crawlability, etc.)</li>
                    <li><CheckCircleOutlineIcon /> Content analysis</li>
                    <li><CheckCircleOutlineIcon /> Domain and page authority check</li>
                    <li><CheckCircleOutlineIcon /> Keyword Projects</li>
                </ul>

                <p style={{display: 'flex', alignItems: 'center', gap: '4px'}}><CreditCardOffIcon style={{fontSize: '17px'}}/>No credit card required</p>
            </Card>

            <Card className='prem'>
                <h2><s style={{color: '#c0c0c0', marginRight: '7px'}}>$29</s>$20/month <span className='limited'>Limited Time!</span></h2>
                <ul className='prem_li'>
                    <li><CheckCircleIcon /> Unlimited usage of Market Lab tools</li>
                    <li><CheckCircleIcon /> Unlimited Keyword projects</li>
                    {/* <li>Unlimited Competition projects</li>
                    <li>Unlimited Backlink profile projects<br/> to track backlinks</li> */}
                    <li><CheckCircleIcon /> Access to any future added project types</li>
                    <li><CheckCircleIcon /> Unlimited access to any future added<br/> market research tools</li>
                </ul>

                <p style={{marginTop: '30px'}}></p>

                {!user.prem && <button onClick={subscribe} style={{color: 'blue', fontFamily: 'Quicksand'}}>Go Premium  <img src={paypal} width={90}/></button>}
            </Card>

            <Card style={{border: 'none', backgroundColor: 'transparent'}}>
                <h3>If you're an occasional user, purchase the <span style={{color: '#de2699'}}>Nexilum</span> units you need in the store whenever you need them.</h3>
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '15px'}}><img src={arrow} width={100}/><button className='go-to-store' onClick={()=> {{window.location.href = 'store'}}}>Go to store</button></div>          
            </Card>
        </CardsContainer>
    </UpgradeContainer>
  )
}

export default Upgrade


const UpgradeContainer = styled.div`
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #f5f5f5;
    z-index: 1000;

    > h1 {
        margin-block: 10px;
        font-family: 'Quicksand';
    }

    > h4 {
        font-weight: 300;
        font-family: 'Quicksand';
    }

    > h4 > .txt_market {
        background-image: linear-gradient(90deg, #a70059, darkblue, #a70059);
        background-clip: text;
        -webkit-background-clip: text; /* For WebKit-based browsers */
        color: transparent;
        font-weight: 400;
        font-family: 'Times New Roman', Times, serif;
    }

    > h4 > .txt_lab {
        color: black;
        font-weight: 400;
        font-family: 'Times New Roman', Times, serif;
    }
`

const shadowAnimation = keyframes`
  0% {
    box-shadow: -8px 0px 20px #fefeac,
                8px 0px 20px #a8ffa881,
                0px -10px 20px #a6d8ff,
                0px 10px 20px  #ffa2cd34;
  }
  25% {
    box-shadow: -10px 0px 20px #a8ffa881,
                10px 0px 20px #fefeac,
                0px -20px 30px #ffa2cd34,
                0px 20px 30px  #a6d8ff;
  }
  75% {
    box-shadow: -10px 0px 20px #ff9d9d,
                10px 0px 20px #a8ffa881,
                0px -20px 30px #a8ffa8,
                0px 20px 30px  #ffa2cd34;
  }
  100% {
    box-shadow: -8px 0px 20px #fefeac,
                8px 0px 20px #a8ffa881,
                0px -10px 20px #a6d8ff,
                0px 10px 20px  #ffa2cd34;
  }
`


const textColor = keyframes`
    0% {
        color: dodgerblue;
    }

    25% {
        color: purple;
    }

    55% {
        color: gold;
    }

    68% {
        color: var(--tst-color);
    }

    79% {
        color: blue;
    }

    100% {
        color: dodgerblue;
    }
`


const CardsContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 60px;
    padding: 10px;
    margin-top: 35px;
    padding-bottom: 50px;

    > .prem {
        animation: ${shadowAnimation} 5s infinite ease-in-out;
    }

    > .reg {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);        
    }
`

const BtnBackgroundEffect = keyframes`
    0% {
        background-color: #fdc2cb89;
    }

    25% {
        background-color: #de2699;
    }

    50% {
        background-color: lightpink;
    }

    75% {
        background-color: #de2699;
    }

    100% {
        background-color: #fdc2cb89;
    }
`

const glow = keyframes`
    0% {
        color: deeppink;
    }
    50% {
        color: pink;
    }
    100% {
        color: deeppink;
    }
`

const Card = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    border: 1px solid lightgray;
    width: 400px;
    height: 450px;
    background-color: white;
    gap: 20px;

    > h2 {
        font-weight: 500;
        text-align: left;
        width: 85%;
        font-family: 'Quicksand';

        > .limited {
            color: deeppink;
            margin-left: 10px;
            font-size: smaller;

            animation: ${glow} 3s ease-in-out infinite;
            font-family: 'Quicksand';
        }

        > s {
            font-family: 'Quicksand';
        }
    }

    > ul {
        list-style-type: none;
    }

    > ul > li {
        color: gray;
        margin-block: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 10px;

        > .MuiSvgIcon-root {
            font-size: medium;
        }
    }

    > .prem_li > li {
       animation: ${textColor} 10s ease-in-out infinite;
    }

    > p {
        margin-top: 50px;
    }


    > button {
        padding: 5px 15px;
        width: fit-content;
        border: 1px solid dodgerblue;
        border-radius: 4px;
        //animation: ${textColor} 10s ease-in-out infinite, ${BtnBackgroundEffect} 7s ease-in-out infinite;
        background-color: transparent;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        cursor: pointer;
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 20px;

        transition: transform 0.3s ease;


        &:hover {
          transform: scale(1.1);
        }
    }

    > h3 {
        font-weight: 300;
        font-family: 'Crimson Text';
    }

    > div > .go-to-store {
        border: none;
        border-radius: 3px;
        padding: 6px 10px;
        background-color: #de2699;
        color: white;
        transition: background-color 0.3s ease-in-out;
        cursor: pointer;
        align-self: flex-start;
        animation: none;

        &:hover {
            background-color: #f2f2f2;
            color: #de2699;
        }
    }
`